export default "__VITE_PUBLIC_ASSET__1280588e__"